const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalDirectorate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.039,1.922c-1.601,0.213-3.149,1.056-3.149,1.056s-3.848,4.48-1.515,11.272 c0.345,0.837,0.642,0.384,1.417,0.958c1.411,1.046,1.779-0.771,3.247-0.758V1.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.957,1.922c1.602,0.213,3.149,1.056,3.149,1.056s3.237,4.116,1.769,11.334 c-0.346,0.837-0.517-0.429-1.291,0.146c-1.411,1.046-2.157-0.021-3.627-0.008V1.922z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.217,23.589l-0.516,5.731H21.88 l-0.552-5.701c1.781-2.813,0.132-5.555,0.132-5.555c-0.153-1.714,0.132-3.957,0.132-3.957c-1.372-0.944-3.338-1.205-4.677-1.262 c-0.141-0.007-0.368-0.015-0.658-0.015c-0.289,0-0.516,0.008-0.657,0.015c-1.339,0.058-3.306,0.318-4.677,1.262 c0,0,0.286,2.242,0.132,3.957C11.055,18.064,9.437,20.776,11.217,23.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.978,27.606l-3.042-5.898l-1.431-1.053 c-0.53,0.698-1.612,1.034-2.474,1.001c0.436,0.654,3.497,5.298,5.06,7.268L12.978,27.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.125,22.25 c-0.934-0.038-4.456-0.244-4.406-0.813c1.723-3.135,3.465-6.624,5.428-7.387c0.302,1.438,1.03,2.665-0.188,5.242L10.125,22.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.845,27.669l3.042-5.898l1.431-1.053 c0.529,0.698,1.611,1.034,2.474,1.001c-0.436,0.654-3.497,5.298-5.06,7.268L19.845,27.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.697,22.313 c0.935-0.038,4.456-0.244,4.406-0.813c-1.723-3.135-3.466-6.624-5.429-7.387c-0.301,1.438-1.029,2.665,0.188,5.242L22.697,22.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M17.455,11.903c-0.517,0.367-1.057,0.41-1.388,0.41c-0.333,0-0.886-0.034-1.42-0.389v0.293 c0.534,0.355,1.087,0.55,1.42,0.55c0.332,0,0.871-0.206,1.388-0.572V11.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.896,13.375l1.313,6.875l-0.75,5h4.583 l-1.833-4.958l1.104-7.183l-0.781-0.141C17.531,12.969,15.932,12.642,13.896,13.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.091,14.504H16.03 c-0.773,0-1.399-0.164-1.399-0.937v-2.663c0-0.772,0.626-1.399,1.399-1.399h0.062c0.773,0,1.399,0.627,1.399,1.399v2.663 C17.49,14.34,16.864,14.504,16.091,14.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.67,6.749 c-0.116-0.026-0.236-0.005-0.352,0.052c0.012-0.197,0.019-0.339,0.021-0.397c0.001-0.022,0.002-0.042,0-0.064 c-0.015-0.359-0.238-3.334-3.413-3.301c-3.174,0.034-3.333,3.014-3.34,3.373c-0.001,0.022,0,0.043,0.001,0.064 c0.004,0.061,0.015,0.211,0.032,0.419c-0.137-0.068-0.277-0.09-0.408-0.051c-0.389,0.115-0.556,0.709-0.373,1.326 c0.178,0.599,0.622,0.999,1.003,0.913c0.083,0.618,0.225,1.142,0.299,1.371c0.506,1.593,2.148,2.043,2.907,2.043 c0.758,0,2.414-0.647,2.824-2.105c0.065-0.23,0.198-0.756,0.269-1.375c0.008,0.002,0.014,0.005,0.021,0.006 c0.396,0.088,0.831-0.35,0.971-0.977C20.273,7.417,20.065,6.837,19.67,6.749z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.026,1.565c4.781,0.028,3.681,5.292,3.215,5.418c0,0-0.926-2.663-2.064-2.631 c-1.043,3.083-3.848,1.291-4.594,2.547C12.015,6.603,11.381,1.538,16.026,1.565z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.295,7.56l0.58,1.887 c0,0,0.052,0.432-0.34,0.458h-0.621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.32,10.989c0,0,0.902,0.366,1.463-0.052"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.49,19.032v5.199 c0,2.369,0.263,4.288,0.588,4.288h12.433c0.325,0,0.59-1.919,0.59-4.288v-5.199H9.49z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.413,
    y: 28.646,
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.927,
    height: 0.454
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.919,
    y: 28.646,
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.925,
    height: 0.454
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.907,29.283h16.829 c0,0-0.234,0.738-0.655,1.02H9.43C9.43,30.303,8.054,30.161,7.907,29.283z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalDirectorate);
export default __webpack_public_path__ + "static/media/medical_directorate.be5f994b830397515478853252ed24e7.svg";
export { ForwardRef as ReactComponent };